module.exports = __webpack_public_path__ + "static/img/bg-16.5b9c3a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/history-bg/bg-16.png
// module id = fKw3
// module chunks = 0